var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.all_classes,attrs:{"src":_vm.imagePath ? _vm.server + '/users/avatar/' + _vm.imagePath : _vm.defaultAvatar()}})}
var staticRenderFns = []

export { render, staticRenderFns }